export enum RewardStatus {
  locked = 'locked',
  unlocked = 'unlocked',
  pending = 'pending',
  expired = 'expired',
  deleted = 'deleted',
  redacted = 'redacted',
}

export enum PaymentStatus {
  eligible = 'eligible',
  notEligible = 'notEligible',
  pendingCashOut = 'pendingCashOut',
  cashOutSuccess = 'cashOutSuccess',
  cashOutFailed = 'cashOutFailed',
}

export enum RewardProcessingStatus {
  queued = 'queued',
  done = 'done',
  error = 'error',
  skipped = 'skipped', // skipped is not a used for checking if a sync session reward processing is complete or not
}

export interface CustomerRewardByStatus {
  rewardStatus: RewardStatus;
  paymentStatus: PaymentStatus;
  rewardAmount: number;
}

export interface CustomerRewardByBrand {
  brandId: number;
  rewardAmount: number;
  additionalMetaData?: {
    id: number;
    name: string;
    brand: any;
  };
}

export interface CustomerRewardByRetailer {
  retailerId: number;
  rewardAmount: number;
  additionalMetaData?: {
    id: number;
    name: string;
    retailer: any;
  };
}

export enum RewardUnlockStrategy {
  Instant = 'instant',
  // Branded Purchase will be assumed default, if missing
  BrandedPurchase = 'brandedPurchase',
}

/**
 * Represents which app platforms the campaign targets
 */
export enum RewardAppTargetingPlatformsType {
  All = 'all',
  BrandclubWebAndMobile = 'brandclubWebAndMobile',
  ClientWebAndMobile = 'clientWebAndMobile',
  ClientWeb = 'clientWeb',
  ClientMobile = 'clientMobile',
}
